export const expireObj = {
    '0': {
        text: '讲师期限：永久',
        showPop: false, // 弹窗
        canUseHtml: true, // 能否使用讲师后台
        showBasicInfo: false // 讲师中心-基本信息 中展示讲师有效期
    },
    // 豆包讲师管理平台使用有效期不足xxx天，请联系商务续期！
    '1': {
        text: '讲师期限：已过期',
        showPop: false,
        canUseHtml: false,
        showBasicInfo: true
    },
    '2': {
        text: '豆包讲师管理平台使用有效期不足15天，请联系商务续期！',
        showPop: true,
        canUseHtml: true,
        showBasicInfo: true
    },
    '3': {
        text: '豆包讲师管理平台使用有效期不足30天，请联系商务续期！',
        showPop: true,
        canUseHtml: true,
        showBasicInfo: true
    },
    '4': {
        text: '讲师期限：有效期内',
        showPop: false,
        canUseHtml: true,
        showBasicInfo: true
    }
}
export const teacherExpireMixin = {
    data(){
        return {
            mixin_expireObj: expireObj
        }
    },
    methods: {
        // 控制讲师过期弹窗
        mixin_handleTeacherExpirePop(userInfo={}){
            // expire_type 讲师过期字段: 0=无限期 1=已过期 2=不足15天 3=不足30天 4=有效期内
            let { account, expire_type } = userInfo
            // console.log('expire_type:',expire_type)
            let newTeacherExpire = `${account}_${expire_type}`
            let storagedExpire = localStorage.getItem('teacher_expire') || ''
            if(!storagedExpire || !storagedExpire.includes('_')) { // 本地还没存储
                if(expireObj[expire_type].showPop){
                    this.mixin_teacherExpirePopFn(expire_type)
                }
            }else{ // 本地已存过
                if(newTeacherExpire != storagedExpire){
                    if(expireObj[expire_type].showPop){
                        this.mixin_teacherExpirePopFn(expire_type)
                    }
                }
            }
            localStorage.setItem('teacher_expire', newTeacherExpire)
        },
        mixin_teacherExpirePopFn(type){
            this.$nextTick(()=>{
                this.$confirm(expireObj[type].text, '提示', {
                    distinguishCancelAndClose: true,
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                })
            })
        }
    }
}